module.exports = __webpack_public_path__ + "static/media/evidence-rospatent.654eda23.pdf";